/**
 * Version 1.0.0
 */

/**
 *  Each element with the class collapsible will have eventListeners created for it,
 *  based on its id.
 *
 * @param {*} afterExpand, callback that is executed after expansion, the first argument is the expanded section, the second it the button.
 * @param {*} afterCollapse, callback that is executed after collapse, the first argument is the collapsed section, the second it the button.s
 */
export function defaultListeners(afterExpand, afterCollapse) {
  document.querySelectorAll(".collapsible").forEach((collapsible) => {
    const selector = collapsible.id.replace(" ", "_");

    // Toggle buttons
    document.querySelectorAll("." + selector + "-toggle").forEach((toggle) => {
      toggle.addEventListener("click", () => {
        console.log(isCollapsed(collapsible));
        if (isCollapsed(collapsible)) {
          expandSection(collapsible);
          enableSection(section);
          afterExpand(collapsible, toggle);
        } else {
          collapseSection(collapsible);
          disableSection(section);
          afterCollapse(collapsible, toggle);
        }
      });
    });

    // Close buttons
    document.querySelectorAll("." + selector + "-close").forEach((close) => {
      close.addEventListener("click", () => {
        collapseSection(collapsible);
        disableSection(section);
        afterCollapse(collapsible, toggle);
      });
    });

    // Open buttons
    document.querySelectorAll("." + selector + "-open").forEach((open) => {
      open.addEventListener("click", () => {
        expandSection(collapsible);
        enableSection(section);
        afterExpand(collapsible, toggle);
      });
    });
  });
}

/**
 * Collapses a given section and disables any inputs contained within it
 */
export function collapseAndDisableSection(section) {
  if (!isCollapsed(section)) {
    collapseSection(section);
  }
  disableSection(section);
}

/**
 * Expands a given section and disables any inputs contained within it
 */
export function expandAndEnableSection(section) {
  enableSection(section);
  if (isCollapsed(section)) {
    expandSection(section);
  }
}

/**
 * Collapses a given section
 */
export async function collapseSection(element, till = 0) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // temporarily disable all css transitions
  var elementTransition = element.style.transition;
  element.style.transition = "";

  // on the next frame (as soon as the previous style change has taken effect),
  // explicitly set the element's height to its current pixel height, so we
  // aren't transitioning out of 'auto'
  requestAnimationFrame(function() {
    element.style.height = sectionHeight + "px";
    element.style.transition = elementTransition;

    // on the next frame (as soon as the previous style change has taken effect),
    // have the element transition to height: 0
    requestAnimationFrame(function() {
      element.style.height = till + "px";
    });
  });
}

/**
 * Expands a given section
 */
export async function expandSection(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // have the element transition to the height of its inner content
  element.style.height = sectionHeight + "px";

  // when the next css transition finishes (which should be the one we just triggered)
  element.addEventListener(
    "transitionend",
    function(e) {
      // remove "height" from the element's inline styles, so it can return to its initial value
      element.style.height = null;
    },
    {
      once: true,
    }
  );
}

/**
 * Disables all input in a section
 * @param {*} element
 */
export function disableSection(element) {
  element.querySelectorAll("input").forEach((input) => {
    input.disabled = true;
  });
}

/**
 * Enables all input in a section
 * @param {*} element
 */
export function enableSection(element) {
  element.querySelectorAll("input").forEach((input) => {
    input.disabled = false;
  });
}

/**
 * Returns if a element is collapsed
 * @param {*} element
 */
function isCollapsed(element) {
  return element.style.height.includes("px");
}
